/**
 * Contract Notices Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.6.13
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ManagementContractNoticeAndAnnouncementFilterRequest { 
    publishedDateFrom?: number;
    publishedDateTo?: number;
    deliveryDateFrom?: number;
    deliveryDateTo?: number;
    estimatedPurchaseValueFrom?: number;
    estimatedPurchaseValueTo?: number;
    agreementValueFrom?: number;
    agreementValueTo?: number;
    searchText?: string;
    contractAuthorityId?: string;
    contractorId?: string;
    mediumId?: string;
    tagIds?: Array<string>;
    types?: Array<ManagementContractNoticeAndAnnouncementFilterRequest.TypesEnum>;
    countries?: Array<ManagementContractNoticeAndAnnouncementFilterRequest.CountriesEnum>;
    createdAtFrom?: number;
    createdAtTo?: number;
    noTags?: boolean;
    autoTaggedAi?: boolean;
    autoTaggedSingleCriteria?: boolean;
    autoTaggedMultipleCriteria?: boolean;
    onlyAdditional?: boolean;
    onlyFake?: boolean;
    /** Hand-added (autotag UI, no live /api-docs yet) - AND with the rest of the filters, OR between the selected colors. */
    colors?: Array<number>;
    /** Hand-added (autotag UI, no live /api-docs yet). */
    reviewed?: boolean;
}
export namespace ManagementContractNoticeAndAnnouncementFilterRequest {
    export type TypesEnum = 'CONTRACT_NOTICE' | 'E_MARKET' | 'CONCESSION' | 'DEFENSE_AND_SECURITY_LAW' | 'SPECIAL_SERVICES' | 'TECHNICAL_DIALOGUES' | 'CONTRACT_AWARD' | 'CANCELLATION' | 'MODIFICATION' | 'LATEST_DECISION';
    export const TypesEnum = {
        CONTRACTNOTICE: 'CONTRACT_NOTICE' as TypesEnum,
        EMARKET: 'E_MARKET' as TypesEnum,
        CONCESSION: 'CONCESSION' as TypesEnum,
        DEFENSEANDSECURITYLAW: 'DEFENSE_AND_SECURITY_LAW' as TypesEnum,
        SPECIALSERVICES: 'SPECIAL_SERVICES' as TypesEnum,
        TECHNICALDIALOGUES: 'TECHNICAL_DIALOGUES' as TypesEnum,
        CONTRACTAWARD: 'CONTRACT_AWARD' as TypesEnum,
        CANCELLATION: 'CANCELLATION' as TypesEnum,
        MODIFICATION: 'MODIFICATION' as TypesEnum,
        LATESTDECISION: 'LATEST_DECISION' as TypesEnum
    };
    export type CountriesEnum = 'MK' | 'AL' | 'XK';
    export const CountriesEnum = {
        MK: 'MK' as CountriesEnum,
        AL: 'AL' as CountriesEnum,
        XK: 'XK' as CountriesEnum
    };
}